var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "pdp-variant-selector-add-to-cart",
      class: [
        {
          "button-fill-no-hover": _vm.hasButtonStateProgress
        },
        {
          "button-fill-no-hover": _vm.hasButtonStateError
        }
      ],
      attrs: { disabled: _vm.addToCartButtonDisabled, type: "button" },
      on: {
        click: function($event) {
          return _vm.add()
        }
      }
    },
    [
      _vm.hasButtonStateProgress
        ? _c("div", { class: { loader: _vm.hasButtonStateProgress } })
        : _vm.hasButtonStateSuccess
        ? _c(
            "div",
            { staticClass: "icon-check-mark" },
            [_c("IconCheckMark")],
            1
          )
        : _vm.hasButtonStateError
        ? _c("div", [_c("IconErrorCross")], 1)
        : _c("div", [
            _vm._v("\n    " + _vm._s(_vm.addToCartButtonText) + "\n  ")
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }